import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { ApiUserService, ApiUsersService } from './services';
import { SnackbarService } from '@fitscovery/ui/snackbar';
import { UserState } from './store';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([ UserState ]),
  ],
  providers: [
    ApiUserService,
    ApiUsersService,
    SnackbarService
  ]
})
export class UserDataAccessModule {

  static forRoot(environment: Environment): ModuleWithProviders<UserDataAccessModule> {
    return {
      ngModule: UserDataAccessModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}
